import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    selectCluster: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        marginTop: "8px",
    },
    selectClusterTitle: {
        color: theme.palette.info.main,
        fontSize: "16px",
        fontWeight: 600,
        fontFamily: "Source Sans 3",
        marginBottom: "20px",
    },
    selectClusterContent: {
        display: "flex",
        gap: "20px",
        flexDirection: "column",
    },
    select: {
        "& .MuiInputBase-input": {
            fontFamily: "Source Sans 3",
            fontSize: "14px",
            fontWeight: "400",
            padding: "9px 12px !important",
            color: `${theme.palette.text.secondary} !important`,
        },
        "& .Mui-disabled": {
            "& .MuiChip-root": {
                backgroundColor: `${theme.palette.border.select} !important`,
                color: `${theme.palette.text.secondary} !important`,
            },
        },
    },
    menuItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between !important",
        gap: 4,
        fontSize: `14px !important`,
        "&.Mui-selected": {
            backgroundColor: `${theme.palette.secondary.main} !important`,
        },
    },
    box: {
        display: "flex !important",
        flexWrap: "wrap",
        gap: 0.5,
    },
    tooltip: {
        marginBottom: `${theme.spacing(2)} !important`,
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Source Sans 3",
            paddingBottom: "5px",
        },
    },
}));
